<template>
  <b-container class="content-wrapper">
    <h4>{{$t('pp:pp-main-title2')}}</h4>
    <p>{{$t('pp:pp-publish')}}</p>
    <privacy-policy-paragraph subtitleTag="pp-sub-title1" :paragraphs="['pp-paragraph11']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title2" :paragraphs="['pp-paragraph21', 'pp-paragraph22', 'pp-paragraph23', 'pp-paragraph24', 'pp-paragraph25']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title3" :paragraphs="['pp-paragraph31', 'pp-paragraph32', 'pp-paragraph33', 'pp-paragraph34', 'pp-paragraph35', 'pp-paragraph36', 'pp-paragraph37']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title4" :paragraphs="['pp-paragraph41', 'pp-paragraph42', 'pp-paragraph43', 'pp-paragraph44', 'pp-paragraph45', 'pp-paragraph46', 'pp-paragraph47']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title5" :paragraphs="['pp-paragraph51', 'pp-paragraph52', 'pp-paragraph53', 'pp-paragraph54', 'pp-paragraph55', 'pp-paragraph56']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title6" :paragraphs="['pp-paragraph61', 'pp-paragraph62', 'pp-paragraph63', 'pp-paragraph64', 'pp-paragraph65']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title7" :paragraphs="['pp-paragraph71', 'pp-paragraph72']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title8" :paragraphs="['pp-paragraph81', 'pp-paragraph82', 'pp-paragraph83', 'pp-paragraph84', 'pp-paragraph85']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title9" :paragraphs="['pp-paragraph91', 'pp-paragraph92', 'pp-paragraph93', 'pp-paragraph94', 'pp-paragraph95', 'pp-paragraph96', 'pp-paragraph97', 'pp-paragraph98', 'pp-paragraph99', 'pp-paragraph991']"/>
    <privacy-policy-paragraph subtitleTag="pp-sub-title10" :paragraphs="['pp-paragraph101']"/>
  </b-container>
</template>
<script>
import PrivacyPolicyParagraph from './PrivacyPolicyParagraph'
export default {
  name: 'PrivacyPolicy',
  components: {
    PrivacyPolicyParagraph
  }
}
</script>

<style scoped>
  .content-wrapper {
    background: var(--white);
    padding-top: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
</style>
